
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/AceBit4.png";
import NavLink from "./navlink";

import ColorToggle from "./colortoggle";

const DesktopTopbar = ({ links }) => {

  return (
    <>
      {links.map((item) => (
        <NavLink target={item.target} key={item.title}>
          <button className="border-none">{item.title}</button>
        </NavLink>
      ))}
    </>
  );
};

export default DesktopTopbar;